/**
 * Which camera the check-in form should open with.
 *
 * On a guest's own phone the rear camera is the right default — they point it
 * at a passport or a vaccine card held in front of them. The Guest Hub runs on
 * a fixed tablet instead, where the rear camera faces a wall: the guest holds
 * the document (and their face) up to the screen, so kiosk mode must start on
 * the front camera. Same reasoning as the kiosk QR scanner, which already
 * forces `facingMode: 'user'`.
 *
 * The manual front/rear toggle still works from whichever side we start on.
 */

import { isKioskRoute } from './kiosk_config';

export function defaultCameraFacingMode(route) {
    return isKioskRoute(route) ? 'user' : 'environment';
}
